import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import _ from 'lodash';

import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import * as modalActions from '../../_shared/modal/modalActions';
import { conditionallyClose } from '../projectActions';

const mapDispatchToProps = (dispatch, ownProps) => ({
  onConfirm: () => {
    dispatch(modalActions.closeModal());
    dispatch(conditionallyClose(ownProps.projectID, ownProps.history, ownProps.projectOpen));
  },
  onCancel: () => dispatch(modalActions.closeModal()),
});

export const ProjectConditionallyCloseModalContent = ({
  onCancel,
  onConfirm,
  projectName,
}) => (
  <Fragment>
    <DialogTitle id="responsive-dialog-title">
      Conditionally Close {projectName}?
    </DialogTitle>
    <DialogContent>
      <DialogContentText>
        You are about to set project {projectName} to Conditional Closure. <br />
        Are you sure you want to proceed?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} color="primary">
        Cancel
      </Button>
      <Button variant="contained" onClick={onConfirm} color="primary">
        Conditionally Close
      </Button>
    </DialogActions>
  </Fragment>
);

ProjectConditionallyCloseModalContent.defaultProps = {
  onCancel: _.noop,
  onConfirm: _.noop,
  projectName: '',
};

ProjectConditionallyCloseModalContent.propTypes = {
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  projectName: PropTypes.string,
};

export default connect(
  null,
  mapDispatchToProps,
)(ProjectConditionallyCloseModalContent);
